"use strict";

exports.__esModule = true;
exports.TimelineValue = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _TimelineValue = require("./TimelineValue.legacy");
var _TimelineValue2 = require("./TimelineValue.modern");
// Flag-gated UI: `TimelineValue.legacy` is the component as it is on master,
// `TimelineValue.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var TimelineValue = exports.TimelineValue = (0, _uiSwitch.uiSwitch)(_TimelineValue.TimelineValue, _TimelineValue2.TimelineValue, "TimelineValue");